export default __webpack_public_path__ + "static/media/sellers tab_market strategy .6dcd8c7b.jpg";